import { ThemeConfig } from 'antd/es/config-provider';
import { CSSProperties } from 'react';
import { platformConfig } from '../config/platform';

export class UI {
  static getTheme = (): ThemeConfig => {
    return {
      token: {
        fontFamily: 'DIN',
        colorPrimary: platformConfig.primaryColor,
        colorLink: platformConfig.primaryColor,
        colorBgContainerDisabled: '#58595B',
        colorTextDisabled: '#fff',
        colorError: platformConfig.primaryColor,
      },
    };
  };

  static modalMaskStyle(): CSSProperties {
    return { backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' };
  }
}
